import React from 'react';
import { styled } from '../../../../theme';
import { BillingDetailsForm } from '../widgets/billing/BillingDetailsForm';

export interface BillingDetailsStepWidgetProps {
  onNext: () => any;
  onCancel: () => any;
}

export const BillingDetailsStepWidget: React.FC<BillingDetailsStepWidgetProps> = (props) => {
  return (
    <>
      <S.Description>
        Confirm your billing details below. Note that the 'Organization name' is the name which will appear on invoices.
      </S.Description>
      <BillingDetailsForm onBack={props.onCancel} onNext={props.onNext} />
    </>
  );
};

namespace S {
  export const Description = styled.p`
    font-size: 14px;
    color: ${(p) => p.theme.text.primary};
    padding-bottom: 20px;
    max-width: 500px;
  `;
}
